import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { MpsUserService } from '../../mps/services/mps-user.service';
import { applicationRouteNames } from '../application-route-names';
import { MpsUser } from '../models/mps-user.model';

/**
 * Route guard that allows access for ADMIN, DELEGATED_MANAGER, and MANAGER roles.
 * Redirects users with the `user` (read-only) role to the contractors list (home).
 */
export const MpsIsManagerOrAboveGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userService = inject(MpsUserService);
  const loggedInUser = userService.getUser();

  if (!loggedInUser) {
    return router.createUrlTree(['/', applicationRouteNames.dashboard]);
  }

  const user = new MpsUser(loggedInUser);

  return user.isManagerOrAbove() ? true : router.createUrlTree(['/', applicationRouteNames.dashboard]);
};
